<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-3 col-lg-4">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title">
                                <h4 class="card-title">profil</h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <form>
                                <div class="form-group">
                                    <div class="crm-profile-img-edit position-relative">
                                        <img v-if="user.genre == 'MALE'" class="crm-profile-pic rounded avatar-100" src="/assets/images/user/04.jpg" alt="profile-pic">
                                        <img v-if="user.genre == 'FEMALE'" class="crm-profile-pic rounded avatar-100" src="/assets/images/user/03.jpg" alt="profile-pic">
                                        <div class="crm-p-image bg-primary">
                                            <i class="las la-pen upload-button"></i>
                                            <input class="file-upload" type="file" accept="image/*">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="furl">Nom : {{user.nom}}</label>
                                </div>
                                <div class="form-group">
                                    <label for="turl">Prenoms : {{user.prenoms}}</label>
                                </div>
                                <div class="form-group">
                                    <label for="instaurl">Contact: {{user.phone}}</label>
                                </div>
                                <div class="form-group">
                                    <label for="lurl">Email: {{user.email}}</label>
                                </div>
                                <div class="form-group">
                                    <label for="lurl">Genre: {{user.genre}}</label>
                                </div>
                                <div class="form-group">
                                    <label> Role: {{user.fonction}}</label>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-xl-9 col-lg-8">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title">
                                <h4 class="card-title">Modifier Information</h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="new-user-info">
                                <form @submit.prevent="store">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for="fname">Nom :</label>
                                            <input type="text" v-model="user.nom" class="form-control" id="fname" placeholder="First Name">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="lname">Prenoms:</label>
                                            <input type="text" v-model="user.prenoms" class="form-control" id="lname" placeholder="Last Name">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="mobno">Contact:</label>
                                            <input type="text" v-model="user.phone" class="form-control" id="mobno" placeholder="Mobile Number">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="email">Email:</label>
                                            <input type="email" v-model="user.email" class="form-control" id="email" placeholder="Email">
                                        </div>
                                    </div>
                                    <hr>
                                    <h5 class="mb-3">Securité</h5>
                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label for="uname">Ancien mot de passe:</label>
                                            <input type="password" v-model="user.password" class="form-control" id="uname" placeholder="password">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="pass">Mot de passe:</label>
                                            <input type="password" v-model="user.newPassword" class="form-control" id="pass" placeholder=" new Password">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="rpass">Confirmer Mot de passe:</label>
                                            <input type="password" v-model="user.password_confirmation" class="form-control" id="rpass" placeholder="Repeat Password ">
                                        </div>
                                    </div>
                                    
                                    <button type="submit" class="btn btn-primary">Enregistrer</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vld-parent">
                     <loading :active.sync="isLoading" 
                     :can-cancel="true" 
                     :is-full-page="fullPage"></loading>
               </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {URL_API} from '@/config'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
export default {
    components: {
        Loading
    },
    data(){
        return{
            isLoading: false,
            user:this.$store.state.user,
            users:null,
            destinations:null,
            events:null,
            depart:null,
        }
    },

    mounted(){
        this.user = this.$store.state.user
        console.log(this.user)
        
    },
    methods:{
       store() {
            if (this.user.newPassword) {
                    if (this.user.newPassword === this.user.password_confirmation) {
                        this.postModify()
                    }else{
                        Swal.fire(
                            'Attention ! ',
                            'mot de passe non conforme',
                            'warning'
                        )
                    }

            }else{
                this.postModify()
            }
                 
        },

        postModify(){
            this.isLoading = true
            axios.post(URL_API+'auth/modifyAccount', this.user)
            .then(response => {
                console.log(response.data)
                this.isLoading = false
                if (response.data.status) {
                    localStorage.setItem('user',JSON.stringify(response.data.user))
                    this.$router.go(-1)
                    Swal.fire(
                        'Operation Effectuée!',
                        'Utilisateur modifié avec succès.',
                        'success'
                    )
                }else{
                    Swal.fire(
                        'Attention ! ',
                        response.data.message,
                        'warning'
                    )
                }

            })
            .catch(error => {
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        }
    }
}

</script>
